export default function getResource(label, vars = []) {
    const resources = {
        estimatedTotal: 'Estimated total'
    };

    return resources[label];
}
